<template>
  <div class="content">
    <BlockUI
      v-if="blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />

    <v-card>
      <v-flex>
        <v-flex style="background-color: var(--secondary-color); padding: 10px">
          <label style="color: white; font-weight: 600; font-size: 20px"
            >Filtros</label
          >
        </v-flex>
      </v-flex>
      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md6 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="search"
                  prepend-icon="search"
                  label="Procurar"
                  single-line
                  hide-details
                />
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-divider />

      <v-card-text>
        <v-data-table
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
          :headers="headers"
          :items="data"
          :search="search"
          class="elevation-1 mt-2"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class>{{ item.pix.id }}</td>
              <td class>{{ item.id }}</td>
              <td class>{{ item.user.name }}</td>
              <td class>{{ item.user.email }}</td>
              <td class>
                {{ (item.total_value_charged / 100) | formatValue }}
              </td>
              <td class>{{ item.created_at | formatDate }}</td>
              <td>
                <ActionButton
                  message="Estornar pagamento"
                  icon="mdi-cash-refund"
                  @onclick="selectPix(item)"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showModal" persistent max-width="600px">
      <form>
        <v-card v-if="selectedPix">
          <v-card-title>
            <span class="headline">Estornar Pix</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex sm6>
                  <v-text-field
                    label="Usuário"
                    v-model="selectedPix.user.name"
                    disabled
                    outlined
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex sm6>
                  <v-text-field
                    label="Valor"
                    v-model="selectedPix.total_value_charged / 100"
                    prefix="R$"
                    disabled
                    outlined
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex sm12>
                  <v-text-field
                    label="Valor estornado"
                    prefix="R$"
                    v-model="pixData.value / 100"
                    required
                    outlined
                    hint="Valor sugerido com 2% de taxa no valor total"
                    :error-messages="valueErrors"
                  ></v-text-field>
                </v-flex>

                <v-flex sm12>
                  <v-text-field
                    label="Senha"
                    required
                    v-model="pixData.password"
                    outlined
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="show1 = !show1"
                    :error-messages="passwordErrors"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="showModal = false"
              >Cancelar</v-btn
            >
            <v-btn
              color="blue darken-1"
              text
              @click.prevent="$v.$invalid ? $v.$touch() : refundPix()"
              >Estornar</v-btn
            >
          </v-card-actions>
        </v-card>
      </form>
    </v-dialog>
  </div>
</template>

<script>
import TransactionController from '../../controllers/TransactionController.js';
import PixController from '../../controllers/PixController.js';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import ActionButton from '../shared/ActionButtonsTemplate';
import moment from 'moment';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
  components: {
    ActionButton,
  },
  async created() {
    await this.getPix();
  },
  data() {
    return {
      search: '',
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      transactionController: new TransactionController(this.$resource),
      pixController: new PixController(this.$resource),
      headers: [
        { text: 'ID Pix', value: 'pix.pix.id' },
        { text: 'ID Transação', value: 'pix.id' },
        { text: 'Usuário', value: 'user.name' },
        { text: 'Email', value: 'user.email' },
        { text: 'Valor', value: 'pix.total_value_charged' },
        { text: 'Data', value: 'pix.created_at' },
        { text: 'Ações', value: 'acoes', sortable: false },
      ],
      data: [],
      showModal: false,
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true,
      },
      selectedPix: null,
      show1: false,
      pixData: {
        value: null,
        password: null,
        user_id: null,
        transaction_id: null,
        e2eId: null,
        id: null,
      },
      transaction: {
        motive: null,
        value: null,
      },
    };
  },
  mixins: [validationMixin],
  validations: {
    pixData: {
      value: { required },
      password: { required },
    },
  },

  computed: {
    valueErrors() {
      const errors = [];
      if (!this.$v.pixData.value.$dirty) return errors;
      !this.$v.pixData.value.required && errors.push('Campo obrigatório.');
      return errors;
    },

    passwordErrors() {
      const errors = [];
      if (!this.$v.pixData.password.$dirty) return errors;
      !this.$v.pixData.password.required && errors.push('Campo obrigatório.');
      return errors;
    },
  },

  methods: {
    async getPix() {
      try {
        this.blockScreen = true;
        const response = await this.transactionController.getPaidPixTransactions();
        this.data = response;
      } catch (error) {
        console.error(err);
      } finally {
        this.blockScreen = false;
      }
    },

    selectPix(item) {
      this.selectedPix = item;
      this.pixData.value =
        item.total_value_charged - item.total_value_charged * (2 / 100);
      this.pixData.transaction_id = item.id;
      this.pixData.e2eId = item.pix.end_to_end_id;
      this.pixData.id = item.pix.id_externo;
      this.showModal = true;
    },

    async refundPix() {
      try {
        this.blockScreen = true;
        this.pixData.user_id = this.selectedPix.user.id;
        const response = await this.pixController.sendPix(this.pixData);
        this.$awn.success('Devolução de pix solicitada!');
      } catch (error) {
        this.$awn.alert(error.body);
      } finally {
        this.blockScreen = false;
      }
    },
  },
  filters: {
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format('DD[/]MM[/]YYYY');
      }
    },

    formatValue(value) {
      let valorFloat = parseFloat(value);
      let formatado = 'R$ ' + valorFloat.toFixed(2).replace('.', ',');
      return formatado;
    },
  },
};
</script>
<style>
.table-custom-vue {
  margin: 25px;
}
.table-custom-vue td:last-child {
  display: flex;
  justify-content: center;
}
</style>
